import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-easy-card',
  templateUrl: './easy-card.component.html',
  styleUrls: ['./easy-card.component.css']
})
export class EasyCardComponent {
  @Input() title: string = '';
  @Input() content: string = '';
  @Input() icon: string = '';
  @Input() color: string = '#311A95';
  @Output() click = new EventEmitter<void>();

  handleclick() {
    this.click.emit();
  }

}
